module.exports = __webpack_public_path__ + "img/no-approve.a858e74f.png";